export default "__VITE_PUBLIC_ASSET__9a9f8026__"